import {
  type RestoreAccount,
  type SourceAccount,
  CloudAccountType,
  type Account,
} from '@repo/api-gw-sdk';

import { isRestoreAccount, isSourceAccount } from '@/utils/accounts';

import { UpdateAccountRoleGcpInnerPanel } from './updateAccountRoleGcpInnerPanel';

export const UpdateAccountGCPPanel = ({
  account,
  onClose,
  onUpdated,
}: {
  account: Account | SourceAccount | RestoreAccount;
  onClose: () => void;
  onUpdated: () => void;
}) => {
  const accountType = isSourceAccount(account)
    ? CloudAccountType.Source
    : isRestoreAccount(account)
      ? CloudAccountType.Restore
      : account.accountType;

  if (
    accountType !== CloudAccountType.Source &&
    accountType !== CloudAccountType.Restore
  ) {
    // vault account API not implemented yet
    throw new Error('Invalid account type');
  }

  return (
    <UpdateAccountRoleGcpInnerPanel
      headerTitle='Update permissions'
      accountType={accountType}
      onUpdated={onUpdated}
      onClose={onClose}
      initialProjectId={account.providerAccountId}
    />
  );
};
